import VCalendar from 'v-calendar'

export default {
  install: (app) => {
    app.use(VCalendar)
  }
}
